import { FeatureCollection, Inspire } from './io';
import { Extent } from 'ol/extent';

import { fetchIO, fetchWithoutValidationIO } from './remote';
import { InspireIO } from './io';
import { getApiUrl } from '../app';

export const fetchLayer = (url: string): Promise<FeatureCollection> =>
    fetchWithoutValidationIO(url);

export const fetchLayerWithExtent = (
    url: string,
    [minx, miny, maxx, maxy]: Extent,
) => fetchLayer(`${url}?bbox=${minx},${miny},${maxx},${maxy}`);

export const fetchDatasetMetadata = (id: string): Promise<Inspire> =>
    fetchIO(InspireIO, getApiUrl(`metadatas/${id}`));
